<template>
  <div class="card-info">
    <div>
      <card-header></card-header>
      <tabs :tabs="tabs" :active="activeTab" @setTab="setTab" />
      <info v-if="activeTab === 0 && id" :id="id" />
      <purchases v-else-if="activeTab === 1 && id" :id="id" />
      <states v-else-if="activeTab === 2 && id" :id="id" />
    </div>
  </div>
</template>
<script>


import CardHeader from "./CardHeader";
import Purchases from "./Order/Purchases";
import States from "./Order/States";
import Info from "./Order/Info";
import Tabs from "../Tabs";
import { errorNotify } from "../../plugins/functions";

export default {
  name: "order",
  props: ["id"],
  components: {
    CardHeader,
    Tabs,
    Purchases,
    Info,
    States,
  },
  data() {
    return {
      loading: true,
      tabs: [
        {
          title: "Информация",
        },
        {
          title: "Товары",
        },
        {
          title: "Отчеты заказа",
        },
      ],
      activeTab: 0,
    };
  },
  methods: {
    setTab(val) {
      this.activeTab = val;
    },
  },
  created() {},
};
</script>